// @flow
import React from 'react'
import Button from '../controls/SmallRoundedButton'

type Props = {|
  label: string,
  onClick: Function
|}

export default function OpenButton({ label, onClick }: Props) {
  return <Button onClick={onClick}>{label}</Button>
}
